import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StockoutreqEditForm from './StockoutreqEditForm';
import StockoutreqList from './StockoutreqList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StockoutreqListView from './StockoutreqListView'


export default function StockoutreqDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stockoutreqDashboard);
  const [ stockoutreqId, setStockoutreqId] = React.useState('');
  const [reloadStockoutreqList, setReloadStockoutreqList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StockoutreqEditForm 
            setReloadStockoutreqList={setReloadStockoutreqList}
            stockoutreqId={stockoutreqId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StockoutreqListView 
                      setStockoutreqId = {setStockoutreqId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
